const AssignTerritories = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="row" style={{ padding: '25px 10px', backgroundColor: '#EDF0F9', borderRadius: '5px', border: 0 }}>
                        <div className="col-3">
                            <label className="mb-1" style={{ color: '#616E88' }}>Module</label>
                            <select className="form-select">
                                <option>Accounts</option>
                            </select>
                        </div>
                        <div className="col-3">
                            <label className="mb-1" style={{ color: '#616E88' }}>Search Accounts by</label>
                            <select className="form-select">
                                <option>Custom View</option>
                                <option>Territory</option>
                                <option>My Own Criteria</option>
                            </select>
                        </div>
                        <div className="col-3">
                            <label className="mb-1" style={{ color: '#616E88' }}>Custom View</label>
                            <select className="form-select">
                                <option>All Accounts</option>
                                <option>All Locked Accounts</option>
                                <option>My Accounts</option>
                                <option>New Last Week</option>
                                <option>New This Week</option>
                                <option>Recently Created Accounts</option>
                                <option>Recently Modified Accounts</option>
                                <option>Unread Accounts</option>
                            </select>
                        </div>
                        <div className="col-3">
                            <label></label>
                            <button className="btn btn-primary btn-blue" type="button">Search</button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default AssignTerritories;